var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureCardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0156 30.2383H20.0156V26.2383H24.0156V30.2383ZM36.0156 30.2383H28.0156V26.2383H36.0156V30.2383ZM16.0156 22.2383H12.0156V18.2383H16.0156V22.2383ZM36.0156 22.2383H20.0156V18.2383H36.0156V22.2383ZM40.0156 40.2383H8.01562C6.95476 40.2383 5.93734 39.8169 5.1872 39.0667C4.43705 38.3166 4.01563 37.2991 4.01562 36.2383V12.2383C4.01562 11.1774 4.43705 10.16 5.1872 9.40985C5.93734 8.65971 6.95476 8.23828 8.01562 8.23828H40.0156C41.0765 8.23828 42.0939 8.65971 42.8441 9.40985C43.5942 10.16 44.0156 11.1774 44.0156 12.2383V36.2383C44.0156 37.2991 43.5942 38.3166 42.8441 39.0667C42.0939 39.8169 41.0765 40.2383 40.0156 40.2383ZM8.01562 12.2383V36.2383H40.0156V12.2383H8.01562Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureCardActive);
export default __webpack_public_path__ + "static/media/Feature_Card_active.59a2ec5e492c976962f5ac2346689c34.svg";
export { ForwardRef as ReactComponent };